<template>
  <div class="passcode-container">
    <div class="passcode-inputs">
      <input
        v-for="(digit, index) in otpField"
        :key="index"
        :type="passwordVisible ? 'text' : 'password'"
        maxlength="1"
        :value="digits[index]"
        @input="onInput($event, index)"
        @keydown.delete="onDelete(index)"
        @keydown.left="focusPrev(index)"
        @keydown.right="focusNext(index)"
        ref="inputs"
      />
      <span v-if="!hideToggleIcon" @click="togglePasswordVisibility" class="toggle-icon">
        <v-icon>{{ localPasswordVisible ? 'mdi-eye' : 'mdi-eye-off' }}</v-icon>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PasscodeInput',
  data() {
    return {
      digits: Array(this.otpField).fill(''),
      localPasswordVisible: false
    }
  },
  props: {
    otpField: { type: Number, default: 6 },
    autoFocus: { type: Boolean, default: false },
    hideToggleIcon: { type: Boolean, default: false },
    isPasswordVisible: { type: Boolean, default: false }
  },
  computed: {
    passwordVisible() {
      if (this.hideToggleIcon) {
        return this.isPasswordVisible
      }
      return this.localPasswordVisible
    }
  },
  watch: {
    otpField(newVal) {
      this.digits = Array(newVal).fill('')
    }
  },
  mounted() {
    if (this.autoFocus) {
      this.$nextTick(() => {
        if (this.$refs.inputs && this.$refs.inputs[0]) {
          this.$refs.inputs[0].focus()
        }
      })
    }
  },
  methods: {
    onInput(event, index) {
      const value = event.target.value
      this.digits[index] = value

      if (value && index < this.otpField - 1) {
        this.$nextTick(() => {
          this.$refs.inputs[index + 1].focus()
        })
      }

      this.emitValue()
    },
    onDelete(index) {
      if (!this.digits[index] && index > 0) {
        this.$nextTick(() => {
          this.$refs.inputs[index - 1].focus()
        })
      }
      this.emitValue()
    },
    focusPrev(index) {
      if (index > 0) {
        this.$refs.inputs[index - 1].focus()
      }
    },
    focusNext(index) {
      if (index < this.otpField - 1) {
        this.$refs.inputs[index + 1].focus()
      }
    },
    emitValue() {
      this.$emit('input', this.digits.join(''))
    },
    togglePasswordVisibility() {
      this.localPasswordVisible = !this.localPasswordVisible
    }
  }
}
</script>

<style scoped>
.passcode-container {
  width: 100%;
  margin: 16px 0;
}
.passcode-inputs {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  align-items: center;
  width: 100%;
}
input {
  width: 44px;
  height: 44px;
  text-align: center;
  border: 2px solid #6366f1;
  border-radius: 12px;
  font-size: 20px;
  font-weight: 700;
  color: #4f46e5;
  background-color: transparent;
  box-shadow: 0 4px 6px -1px rgba(99, 102, 241, 0.1), 0 2px 4px -2px rgba(99, 102, 241, 0.1);
  transition: all 0.2s ease;
}
input:focus {
  outline: none;
  border-color: #4f46e5;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.25);
  background-color: #f5f3ff;
}
.toggle-icon {
  cursor: pointer;
  font-size: 20px;
  color: #6b7280;
  margin-left: 6px;
  display: flex;
  align-items: center;
  transition: color 0.2s;
}
.toggle-icon:hover {
  color: #374151;
}
</style>
